import { createSlice } from '@reduxjs/toolkit';
import {
  EditAdminOrder,
  EditAdminPaymentOrder,
  EditAdminSingleOrder,
  GetAdminSingleOrder,
  GetAllCountOrders,
  GetAUsersOrders,
  GetAUserStatusOrders,
  GetOrders,
  GetSelectionOrders,
  GetStatusOrders,
  SearchForOrdersByName,
} from './admin_order_services_sync';

export const adminOrderSlice = createSlice({
  name: 'admin_order',
  initialState: {
    my_order_loader: false,
    my_order_details_loader: false,
    order_edit_loader: false,
    order_edit_single_loader: false,
    users_order_loader: false,
    users_order_status_loader: false,
    status_order_loader: false,
    order_edit_payment_loader: false,
    order_all_count_loader: false,
    message: '',
    my_order: [],
    myOrderDetails: {},
    my_order_search_details: {},
    cartIndicator: '',
    orderPage: 0,
    orderLimit: 20,
    allCountOrder: 0,
    my_order_status: 'all',
    my_single_order_status: '',
    my_single_payment_status: '',
    my_selection_order_status: { value: 'all', label: 'All' },
    users_order: {},
    users_page: 0,
    users_limit: 10,
    users_status_order: {},
    status_order: {},
  },
  reducers: {
    clearState: (state) => {
      state.my_order_loader = false;
      state.my_order_details_loader = false;
      state.order_edit_loader = false;
      state.order_edit_single_loader = false;
      state.order_edit_payment_loader = false;
      state.order_all_count_loader = false;
      state.message = '';
      state.my_order = [];
      state.myOrderDetails = {};
      state.my_order_search_details = {};
      state.orderIndicator = '';
      state.orderPage = 0;
      state.my_order_status = 'all';
      state.my_single_order_status = '';
      state.my_single_payment_status = '';
      state.my_selection_order_status = { value: 'all', label: 'All' };
      state.users_order = {};
      state.users_page = 0;
      state.users_limit = 10;
      state.allCountOrder = 0;
      state.users_order_loader = false;
      state.users_order_status_loader = false;
      state.status_order_loader = false;
      state.users_status_order = {};
      state.status_order = {};

      return state;
    },

    updateOrderIndicator: (state, { payload }) => {
      state.orderIndicator = payload;
    },

    updateMyOrderStatus: (state, { payload }) => {
      state.my_order_status = payload;
    },

    updateMySelectionOrdeState: (state, { payload }) => {
      state.my_selection_order_status = payload;
    },

    updateMySingleOrderStatus: (state, { payload }) => {
      state.my_single_order_status = payload;
    },

    updateMySinglePaymentStatus: (state, { payload }) => {
      state.my_single_payment_status = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetOrders.pending, (state) => {
        state.my_order_loader = true;
      })
      .addCase(GetOrders.fulfilled, (state, { payload }) => {
        state.my_order_loader = false;
        state.message = payload?.message;
        state.my_order = payload?.data;
        state.orderPage = payload?.data?.page;
        state.my_selection_order_status = { value: 'all', label: 'All' };
      })
      .addCase(GetOrders.rejected, (state, { payload }) => {
        state.my_order_loader = false;
        state.message = payload?.message;
      });

    builder
      .addCase(GetSelectionOrders.pending, (state) => {
        state.my_order_loader = true;
      })
      .addCase(GetSelectionOrders.fulfilled, (state, { payload }) => {
        state.my_order_loader = false;
        state.message = payload?.message;
        state.my_order = payload?.data;
        state.orderPage = payload?.data?.page;
        state.my_selection_order_status = payload?.my_selection_order;
      })
      .addCase(GetSelectionOrders.rejected, (state, { payload }) => {
        state.my_order_loader = false;
        state.message = payload?.message;
      });

    builder
      .addCase(GetAdminSingleOrder.pending, (state) => {
        state.my_order_details_loader = true;
      })
      .addCase(GetAdminSingleOrder.fulfilled, (state, { payload }) => {
        state.my_single_order_status = payload?.data?.status;

        state.my_order_details_loader = false;
        state.message = payload?.message;
        state.myOrderDetails = payload?.data;
      })
      .addCase(GetAdminSingleOrder.rejected, (state, { payload }) => {
        state.my_order_details_loader = false;
        state.message = payload?.message;
      });

    builder
      .addCase(EditAdminOrder.pending, (state) => {
        state.order_edit_loader = true;
      })
      .addCase(EditAdminOrder.fulfilled, (state, { payload }) => {
        const full_list = state.my_order?.docs;

        const findIndex = full_list?.findIndex(
          (item) => item?._id === payload?.data?._id
        );

        full_list?.splice(findIndex, 1, payload?.data);

        state.my_order = { ...state.my_order, docs: full_list };

        state.order_edit_loader = false;
        state.message = payload?.message;

        state.orderIndicator = '';
      })
      .addCase(EditAdminOrder.rejected, (state, { payload }) => {
        state.order_edit_loader = false;
        state.message = payload?.message;
        state.orderIndicator = '';
      });

    builder
      .addCase(EditAdminSingleOrder.pending, (state) => {
        state.order_edit_single_loader = true;
      })
      .addCase(EditAdminSingleOrder.fulfilled, (state, { payload }) => {
        state.order_edit_single_loader = false;
        state.message = payload?.message;

        state.myOrderDetails = payload?.data;
      })
      .addCase(EditAdminSingleOrder.rejected, (state, { payload }) => {
        state.order_edit_single_loader = false;
        state.message = payload?.message;
      });

    builder
      .addCase(EditAdminPaymentOrder.pending, (state) => {
        state.order_edit_payment_loader = true;
      })
      .addCase(EditAdminPaymentOrder.fulfilled, (state, { payload }) => {
        state.order_edit_payment_loader = false;
        state.message = payload?.message;

        state.myOrderDetails = payload?.data;
      })
      .addCase(EditAdminPaymentOrder.rejected, (state, { payload }) => {
        state.order_edit_payment_loader = false;
        state.message = payload?.message;
      });

    builder
      .addCase(GetAUsersOrders.pending, (state) => {
        state.users_order_loader = true;
      })
      .addCase(GetAUsersOrders.fulfilled, (state, { payload }) => {
        state.users_order_loader = false;
        state.message = payload?.message;

        state.users_order = payload?.data;
        state.users_page = payload?.data?.page;
      })
      .addCase(GetAUsersOrders.rejected, (state, { payload }) => {
        state.users_order_loader = false;
        state.message = payload?.message;
      });

    builder
      .addCase(GetAUserStatusOrders.pending, (state) => {
        state.users_order_status_loader = true;
      })
      .addCase(GetAUserStatusOrders.fulfilled, (state, { payload }) => {
        state.users_order_status_loader = false;
        state.message = payload?.message;

        state.users_status_order = payload?.data;
      })
      .addCase(GetAUserStatusOrders.rejected, (state, { payload }) => {
        state.users_order_status_loader = false;
        state.message = payload?.message;
      });

    builder
      .addCase(GetStatusOrders.pending, (state) => {
        state.status_order_loader = true;
      })
      .addCase(GetStatusOrders.fulfilled, (state, { payload }) => {
        state.status_order_loader = false;
        state.message = payload?.message;

        state.status_order = payload?.data;
      })
      .addCase(GetStatusOrders.rejected, (state, { payload }) => {
        state.status_order_loader = false;
        state.message = payload?.message;
      });

    builder
      .addCase(GetAllCountOrders.pending, (state) => {
        state.order_all_count_loader = true;
      })
      .addCase(GetAllCountOrders.fulfilled, (state, { payload }) => {
        state.order_all_count_loader = false;
        state.message = payload?.message;

        state.allCountOrder = payload?.data;
      })
      .addCase(GetAllCountOrders.rejected, (state, { payload }) => {
        state.order_all_count_loader = false;
        state.message = payload?.message;
      });

    builder
      .addCase(SearchForOrdersByName.pending, (state) => {
        state.my_order_loader = true;
      })
      .addCase(SearchForOrdersByName.fulfilled, (state, { payload }) => {
        state.my_order_loader = false;
        state.message = payload?.message;

        state.my_order_search_details = payload?.data;
      })
      .addCase(SearchForOrdersByName.rejected, (state, { payload }) => {
        state.my_order_loader = false;
        state.message = payload?.message;
      });
  },
});

export const {
  clearState,
  updateOrderIndicator,
  updateMyOrderStatus,
  updateMySelectionOrdeState,
  updateMySingleOrderStatus,
  updateMySinglePaymentStatus,
} = adminOrderSlice.actions;
export const adminOrderSelector = (state) => state.admin_order;

export default adminOrderSlice.reducer;
